<template>
  <div class="pagebottom">
    <div class="layout">
      <div class="top">
        <div class="logo"><img :src="cdnUrl + '/web_assets/img/logo.png'" alt="" /></div>
        <div class="subscribe">
          <input type="text" placeholder="YOUR EMAIL ADDRESS" v-model="emailAddress" />
          <ui_btn_1 :width="'2.28rem'" @click="subscribe">{{
            lang == "en" ? "subscribe" : "訂閱"
          }}</ui_btn_1>
        </div>
      </div>
      <div class="bot">
        <div class="left" @click="set_appErrorLogShowTag">
          Copyrights @ {{ fullYear }} BLOCK WAR - All Rights Reserved
        </div>
        <div class="right">
          <!-- twitter -->
          <a href=""
            ><svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_338_7191)">
                <path
                  d="M43.898 11.6739C42.4343 12.3053 40.8415 12.7597 39.2009 12.9366C40.8941 11.9274 42.1808 10.3346 42.7883 8.44047C41.2242 9.37319 39.4544 10.0572 37.6129 10.4111C36.1205 8.81834 34.0016 7.83301 31.6531 7.83301C27.133 7.83301 23.4978 11.4969 23.4978 15.9931C23.4978 16.6245 23.5743 17.2558 23.6987 17.8633C16.9305 17.5093 10.8941 14.2759 6.88106 9.32535C6.17315 10.5403 5.77137 11.9274 5.77137 13.4437C5.77137 16.2753 7.2111 18.7721 9.40657 20.2405C8.06728 20.1879 6.80453 19.81 5.71875 19.2026V19.303C5.71875 23.2683 8.52169 26.5543 12.2573 27.31C11.5733 27.487 10.8415 27.5875 10.1097 27.5875C9.57876 27.5875 9.07653 27.5349 8.56952 27.4631C9.60268 30.6965 12.6113 33.0451 16.1939 33.1216C13.3909 35.3171 9.8801 36.6085 6.06792 36.6085C5.38393 36.6085 4.75255 36.5846 4.09726 36.5081C7.71333 38.8279 12.0038 40.1672 16.6244 40.1672C31.6244 40.1672 39.8323 27.7405 39.8323 16.9545C39.8323 16.6005 39.8323 16.2466 39.8084 15.8926C41.3964 14.7303 42.7883 13.2906 43.898 11.6739Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_338_7191">
                  <rect width="48" height="48" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
          <!-- discord -->
          <a href=""
            ><svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_338_7205)">
                <path
                  d="M18.973 6.26514L17.7417 6.41333C17.7417 6.41333 12.2176 7.01714 8.18323 10.2569H8.13593L8.08548 10.3042C7.18055 11.1366 6.78642 12.1598 6.16369 13.6559C5.42963 15.4559 4.80472 17.2986 4.29235 19.1738C3.12256 23.4036 2.17349 28.5273 2.17349 33.2144V33.6085L2.37056 34.0026C3.83043 36.5645 6.42224 38.1962 8.82487 39.3234C11.2259 40.4506 13.3022 41.0481 14.7369 41.097L15.6733 41.1459L16.1652 40.3087L17.8899 37.2534C19.7187 37.6665 21.8249 37.9439 24.2449 37.9439C26.6649 37.9439 28.7711 37.6665 30.5999 37.2534L32.3246 40.3087L32.8181 41.1459L33.753 41.097C35.1876 41.0481 37.2639 40.4506 39.665 39.3234C42.0676 38.1962 44.6594 36.5645 46.1193 34.0026L46.3163 33.6085V33.2144C46.3163 28.5273 45.3673 23.4036 44.1975 19.1738C43.6851 17.2986 43.0602 15.4559 42.3261 13.6559C41.7034 12.1582 41.3093 11.1366 40.4044 10.3058L40.3555 10.2553H40.305C36.2738 7.01714 30.7481 6.41333 30.7481 6.41333L29.5168 6.26514L29.0723 7.39866C29.0723 7.39866 28.6166 8.54953 28.3344 9.86278C26.9791 9.67578 25.6131 9.57678 24.2449 9.56639C23.4015 9.56639 21.9432 9.62157 20.1554 9.86278C19.8716 8.54953 19.416 7.39866 19.416 7.39866L18.973 6.26514ZM16.8053 9.86278C16.8731 10.0835 16.9409 10.2743 17.0023 10.454C14.9639 10.9585 12.7898 11.7278 10.7955 12.9654L12.4698 15.6266C16.5593 13.0884 22.4335 12.7195 24.2449 12.7195C26.0548 12.7195 31.9305 13.0884 36.02 15.6266L37.6943 12.9654C35.7 11.7278 33.526 10.9585 31.4875 10.4524C31.549 10.2743 31.6168 10.0835 31.6846 9.8612C33.1555 10.1576 35.9648 10.8355 38.2855 12.6706C38.2729 12.6769 38.8767 13.5881 39.419 14.8872C39.974 16.2241 40.5888 18.004 41.1438 20.0109C42.2095 23.8592 43.0466 28.5462 43.1144 32.672C42.1212 34.1871 40.2814 35.5539 38.3344 36.4667C37.1133 37.0437 35.8215 37.4572 34.4924 37.6964L33.7041 36.3674C34.1723 36.194 34.6343 36.0048 35.0347 35.8251C37.461 34.7594 38.779 33.6085 38.779 33.6085L36.709 31.2437C36.709 31.2437 35.823 32.0572 33.753 32.9684C31.6861 33.8796 28.5252 34.7909 24.2449 34.7909C19.9646 34.7909 16.8053 33.8796 14.7369 32.9684C12.6669 32.0572 11.7809 31.2437 11.7809 31.2437L9.71089 33.6085C9.71089 33.6085 11.0289 34.7594 13.4551 35.8251C13.8556 36.0048 14.3175 36.1956 14.7857 36.3674L13.9975 37.698C12.6676 37.4579 11.3753 37.0434 10.1539 36.4652C8.20845 35.5539 6.36706 34.1871 5.377 32.672C5.44322 28.5462 6.28035 23.8592 7.34767 20.0109C7.81929 18.2701 8.3947 16.5592 9.07081 14.8872C9.61314 13.5881 10.217 12.6769 10.2043 12.6706C12.525 10.8355 15.3344 10.1576 16.8053 9.86278V9.86278ZM18.7271 20.6021C17.5084 20.6021 16.4301 21.2974 15.7711 22.1786C15.1121 23.0599 14.7857 24.143 14.7857 25.3317C14.7857 26.5204 15.1121 27.6035 15.7711 28.4848C16.4301 29.366 17.5084 30.0613 18.7271 30.0613C19.9457 30.0613 21.0241 29.366 21.6831 28.4848C22.342 27.6035 22.6684 26.5204 22.6684 25.3317C22.6684 24.143 22.342 23.0599 21.6831 22.1786C21.0241 21.2974 19.9457 20.6021 18.7271 20.6021ZM29.7628 20.6021C28.5441 20.6021 27.4658 21.2974 26.8068 22.1786C26.1478 23.0599 25.8215 24.143 25.8215 25.3317C25.8215 26.5204 26.1478 27.6035 26.8068 28.4848C27.4658 29.366 28.5441 30.0613 29.7628 30.0613C30.9814 30.0613 32.0598 29.366 32.7188 28.4848C33.3778 27.6035 33.7041 26.5204 33.7041 25.3317C33.7041 24.143 33.3778 23.0599 32.7188 22.1786C32.0598 21.2974 30.9814 20.6021 29.7628 20.6021ZM18.7271 23.7552C18.8138 23.7552 18.9241 23.7867 19.1212 24.0516C19.3183 24.3148 19.5153 24.7768 19.5153 25.3317C19.5153 25.8866 19.3183 26.3486 19.1212 26.6134C18.9241 26.8767 18.8138 26.9082 18.7271 26.9082C18.6404 26.9082 18.53 26.8767 18.3329 26.6118C18.0722 26.2362 17.9345 25.7889 17.9388 25.3317C17.9388 24.7768 18.1359 24.3148 18.3329 24.05C18.53 23.7867 18.6404 23.7552 18.7271 23.7552ZM29.7628 23.7552C29.8495 23.7552 29.9598 23.7867 30.1569 24.0516C30.354 24.3148 30.551 24.7768 30.551 25.3317C30.551 25.8866 30.354 26.3486 30.1569 26.6134C29.9598 26.8767 29.8495 26.9082 29.7628 26.9082C29.6761 26.9082 29.5657 26.8767 29.3686 26.6118C29.1079 26.2362 28.9702 25.7889 28.9745 25.3317C28.9745 24.7768 29.1716 24.3148 29.3686 24.05C29.5657 23.7867 29.6761 23.7552 29.7628 23.7552Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_338_7205">
                  <rect width="48" height="48" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
          <!-- Telegram -->
          <a href=""
            ><svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M41.6112 8.24736C40.9302 7.54196 40.0002 7.13091 39.0202 7.10205C38.5168 7.10302 38.0188 7.20518 37.5557 7.40246L6.38833 20.9021C6.02075 21.0518 5.71008 21.3142 5.50093 21.6515C5.29179 21.9888 5.19492 22.3838 5.22425 22.7796V24C5.2041 24.4118 5.32004 24.8188 5.55418 25.1581C5.78832 25.4974 6.12764 25.7503 6.51976 25.8776L14.612 28.5812L17.0528 36.8237C17.2169 37.4015 17.5337 37.9244 17.9698 38.3374C18.4059 38.7504 18.9453 39.0382 19.5312 39.1706C19.7556 39.1983 19.9827 39.1983 20.2071 39.1706C21.0399 39.1677 21.8397 38.8451 22.4414 38.2694L25.4267 35.4531L31.2096 40.0155C31.7647 40.449 32.4306 40.7176 33.1311 40.7906C33.8316 40.8636 34.5386 40.7382 35.1712 40.4286L35.7908 40.1094C36.3206 39.837 36.7808 39.4464 37.1356 38.9678C37.4905 38.4893 37.7306 37.9355 37.8373 37.3494L42.7753 11.8147C42.8912 11.1702 42.8455 10.507 42.6424 9.88446C42.4392 9.26192 42.0849 8.69944 41.6112 8.24736V8.24736ZM35.0773 36.8988C35.0467 37.061 34.9802 37.2142 34.8828 37.3474C34.7853 37.4806 34.6593 37.5903 34.514 37.6686L33.8945 37.9878C33.7723 38.0499 33.6372 38.0821 33.5002 38.0816C33.3002 38.0779 33.1078 38.0049 32.9557 37.8751L25.8961 32.2425C25.7278 32.0933 25.5107 32.011 25.2859 32.011C25.061 32.011 24.844 32.0933 24.6757 32.2425L20.5075 36.1665C20.4309 36.2228 20.3395 36.2554 20.2447 36.2604V29.6327C20.2449 29.5025 20.2717 29.3738 20.3233 29.2544C20.375 29.1349 20.4504 29.0273 20.5451 28.938C26.5345 23.3053 30.1206 20.151 32.261 18.3486C32.3291 18.2863 32.3841 18.211 32.4228 18.1272C32.4615 18.0434 32.4831 17.9527 32.4863 17.8604C32.4938 17.7702 32.4808 17.6794 32.4483 17.5948C32.4158 17.5103 32.3646 17.4342 32.2985 17.3723C32.207 17.2573 32.0796 17.1763 31.9367 17.1423C31.7937 17.1083 31.6435 17.1231 31.51 17.1845L17.3157 26.1404C17.1896 26.2005 17.0517 26.2316 16.912 26.2316C16.7723 26.2316 16.6344 26.2005 16.5083 26.1404L8.04058 23.249L38.5883 9.99348C38.6994 9.96713 38.8152 9.96713 38.9263 9.99348C39.0622 9.99704 39.1959 10.0289 39.3187 10.0871C39.4416 10.1453 39.5509 10.2285 39.6398 10.3314C39.7679 10.4676 39.8619 10.6321 39.9141 10.8116C39.9663 10.9912 39.9753 11.1805 39.9402 11.3641L35.0773 36.8988Z"
                fill="white"
              />
            </svg>
          </a>
          <!-- youtube -->
          <a href=""
            ><svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_338_7188)">
                <path
                  d="M28.8389 31.8396V36.7418C28.8389 37.7792 28.537 38.2979 27.9334 38.2979C27.5769 38.2979 27.2282 38.1274 26.8873 37.7866V30.7936C27.2282 30.4527 27.5769 30.2823 27.9334 30.2823C28.537 30.2823 28.8389 30.8009 28.8389 31.8383V31.8396ZM36.6918 31.863V32.9311H34.6011V31.863C34.6011 30.81 34.9498 30.2836 35.6471 30.2836C36.3445 30.2836 36.6931 30.81 36.6931 31.863H36.6918ZM14.2492 26.7981H16.7355V24.6137H9.48749V26.7981H11.9269V40.0178H14.2505V26.7981H14.2492ZM20.9404 40.0178H23.0077V28.5415H20.9404V37.3234C20.4755 37.9739 20.034 38.2992 19.6159 38.2992C19.3375 38.2992 19.1749 38.1365 19.1281 37.8113C19.1124 37.7644 19.1046 37.4934 19.1046 36.9981V28.5415H17.0373V37.6252C17.0373 38.3842 17.0993 38.9497 17.2234 39.3218C17.409 39.8951 17.8583 40.1817 18.5712 40.1817C19.3145 40.1817 20.1042 39.7095 20.9404 38.7649V40.0191V40.0178ZM30.9075 36.5792V32.0022C30.9075 30.8712 30.8377 30.1045 30.698 29.702C30.4344 28.8347 29.8845 28.401 29.0483 28.401C28.2738 28.401 27.5535 28.8191 26.8873 29.6552V24.6137H24.82V40.0165H26.8873V38.9015C27.5847 39.7533 28.305 40.1791 29.0483 40.1791C29.8845 40.1791 30.4344 39.7533 30.698 38.9015C30.8377 38.4835 30.9075 37.7089 30.9075 36.5779V36.5792ZM38.7592 36.3476V36.0458H36.645C36.645 36.8359 36.6294 37.3082 36.5982 37.4626C36.4897 38.0203 36.1801 38.2992 35.6692 38.2992C34.9571 38.2992 34.6011 37.7649 34.6011 36.6963V34.6745H38.7592V32.2819C38.7592 31.0581 38.5501 30.16 38.1321 29.5875C37.5284 28.7974 36.7074 28.4023 35.6692 28.4023C34.6163 28.4023 33.7875 28.7974 33.183 29.5875C32.7493 30.1608 32.5325 31.059 32.5325 32.2819V36.3008C32.5325 37.5246 32.7571 38.4228 33.2064 38.9952C33.8101 39.7854 34.6466 40.1804 35.7161 40.1804C36.8315 40.1804 37.668 39.7702 38.2257 38.9497C38.5042 38.5316 38.6668 38.1135 38.7136 37.6955C38.7448 37.5558 38.7605 37.1066 38.7605 36.3476H38.7592ZM24.634 15.1358V10.257C24.634 9.18839 24.3009 8.6541 23.6348 8.6541C22.9687 8.6541 22.6356 9.18839 22.6356 10.257V15.1358C22.6356 16.22 22.9687 16.7621 23.6348 16.7621C24.3009 16.7621 24.634 16.22 24.634 15.1358ZM41.3378 32.5838C41.3378 36.2084 41.1366 38.9189 40.7341 40.7151C40.5173 41.6293 40.068 42.3961 39.3862 43.0154C38.7045 43.6346 37.9148 43.9907 37.0171 44.0835C34.167 44.4087 29.8688 44.5714 24.1227 44.5714C18.3765 44.5714 14.0784 44.4087 11.2283 44.0835C10.3297 43.9907 9.53606 43.6346 8.84738 43.0154C8.15871 42.3961 7.71333 41.6293 7.51124 40.7151C7.10879 38.9805 6.90756 36.27 6.90756 32.5838C6.90756 28.9591 7.10879 26.2487 7.51124 24.4524C7.72807 23.5382 8.17736 22.7715 8.85909 22.1522C9.54083 21.5329 10.3384 21.1691 11.2517 21.0606C14.0862 20.751 18.3765 20.5962 24.1227 20.5962C29.8688 20.5962 34.167 20.751 37.0171 21.0606C37.9157 21.1691 38.7093 21.5329 39.398 22.1522C40.0866 22.7715 40.532 23.5382 40.7341 24.4524C41.1366 26.1871 41.3378 28.8975 41.3378 32.5838V32.5838ZM18.1523 2.93872H20.5214L17.7099 12.2085V18.5041H15.3863V12.2085C15.1695 11.0627 14.6972 9.42084 13.9695 7.28283C13.3962 5.68778 12.8927 4.23974 12.459 2.93872H14.9218L16.5715 9.04831L18.1523 2.93872ZM26.7481 10.6746V14.7403C26.7481 15.9945 26.5313 16.9082 26.0976 17.4815C25.5243 18.2717 24.7034 18.6668 23.6348 18.6668C22.5974 18.6668 21.7843 18.2717 21.1954 17.4815C20.7617 16.8926 20.5449 15.9788 20.5449 14.7403V10.6746C20.5449 9.43515 20.7617 8.52921 21.1954 7.95676C21.7843 7.1666 22.5974 6.77153 23.6348 6.77153C24.7034 6.77153 25.5243 7.1666 26.0976 7.95676C26.5313 8.53007 26.7481 9.43602 26.7481 10.6746V10.6746ZM34.5308 6.91204V18.5054H32.4167V17.2278C31.5962 18.188 30.7986 18.6681 30.0241 18.6681C29.312 18.6681 28.8549 18.3814 28.6528 17.8081C28.5288 17.436 28.4668 16.8553 28.4668 16.066V6.91204H30.5809V15.4389C30.5809 15.9498 30.5887 16.2208 30.6044 16.2521C30.6512 16.5929 30.8138 16.7634 31.0922 16.7634C31.5103 16.7634 31.9518 16.4303 32.4167 15.7642V6.91204H34.5308V6.91204Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_338_7188">
                  <rect
                    width="41.6327"
                    height="41.6327"
                    fill="white"
                    transform="translate(3.42856 2.93872)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
          <!-- medium -->
          <a href=""
            ><svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_338_7194)">
                <g clip-path="url(#clip1_338_7194)">
                  <ellipse
                    cx="15.4564"
                    cy="20.8162"
                    rx="11.718"
                    ry="11.718"
                    fill="white"
                  />
                  <ellipse
                    cx="33.6193"
                    cy="20.8162"
                    rx="5.859"
                    ry="11.1321"
                    fill="white"
                  />
                  <ellipse
                    cx="42.7008"
                    cy="20.8163"
                    rx="2.05065"
                    ry="9.96031"
                    fill="white"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_338_7194">
                  <rect width="48" height="48" fill="white" />
                </clipPath>
                <clipPath id="clip1_338_7194">
                  <rect
                    width="54.3673"
                    height="54.3673"
                    fill="white"
                    transform="translate(-2.93878 -6.36743)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.pagebottom {
  height: 5.8rem;
  background-color: #1b203f;
  text-align: center;
  padding-top: 0.75rem;
  padding-bottom: 0.7rem;
  box-sizing: border-box;

  .layout {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    margin-bottom: 0.61rem;

    img {
      width: 1rem;
      height: auto;
    }
  }

  .subscribe {
    width: 12rem;
    height: 1rem;
    box-sizing: border-box;
    padding: 0.2rem;
    border: 1px solid #eb4046;
    background-color: #0c1336;
    border-radius: 0.2rem;
    text-align: right;
    display: flex;
    justify-content: space-between;

    input {
      border-width: 0;
      outline: 0;
      background-color: transparent;
      font-size: 0.24rem;
      color: #fff;
    }

    .btn1 {
      margin-left: 0.2rem;
    }

    input {
      width: 7.68rem;
    }
  }

  .bot {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 0.18rem;

    .right {
      margin-left: 2.5rem;

      svg {
        width: 0.48rem;
        height: 0.48rem;
        margin-left: 0.5rem;
      }
    }
  }
}
</style>
<script>
/* 
提交訂閱 /subscribe/apply 請求方法: POST(json格式) 參數: email string 電子郵件地址 返回: { code: int msg: string }
http://docs.wargamedev.com/server/protocol/web/subscribe.txt

訂閱接口，和強哥的地址一樣，header要求也一樣
 */
import axios from "axios";
import { defineComponent, ref, computed } from "vue";
import { useStore } from "vuex";
// import { useRouter } from "vue-router";
import common from "../../utils/common";

import ui_btn_1 from "../ui/ui_btn_1.vue";

export default defineComponent({
  name: "pagebottom",
  props: {},
  components: { ui_btn_1 },
  setup(props, ctx) {
    // let router = useRouter();
    let store = useStore();
    let lang = computed(() => {
      return store.state.lang;
    });
    let cdnUrl = computed(() => {
      return store.state.cdnUrl;
    });
    let appErrorLogShowTag = computed(() => {
      return store.state.appErrorLogShowTag;
    });
    const set_appErrorLogShowTag = () => {
      store.commit("set_appErrorLogShowTag", !appErrorLogShowTag.value);
    };

    let fullYear = new Date().getFullYear();
    let emailAddress = ref("");
    const subscribe = () => {
      if (emailAddress.value && common.form.reg.eREG.test(emailAddress.value)) {
        common.showLoading("subscribe");
        // const sendUrl = common.userApi.requestUrl + "/subscribe/apply";
        const sendUrl = common.userApi.requestUrl + "/extra_api/subscribe";
        const sendData = common.buildSendData({ email: emailAddress.value });
        const sendHeader = common.buildHeaders("form", {});
        axios
          .post(sendUrl, sendData, { headers: sendHeader })
          .then((r) => {
            console.log("--lb", r);
            if (r.data.code == 0) {
              toastr["success"](common.msg.opSuccess);
            } else {
              toastr["error"](r.data.msg);
            }
          })
          .catch((e) => {
            console.error(e);
            toastr["error"](e);
          })
          .finally(() => {
            common.hideLoading("subscribe");
          });
      } else {
        toastr["error"](common.msg.inputIsInvalidt);
      }
    };

    return {
      cdnUrl,
      lang,
      set_appErrorLogShowTag,
      appErrorLogShowTag,
      emailAddress,
      subscribe,
      fullYear,
    };
  },
});
</script>
